function delayPromise(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}
export default delayPromise;